import styled from 'styled-components';
import { FrameHeaderHeight } from 'styles/constants';

import { BlockSize } from 'libs/rendering/gltf/config';

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@chakra-ui/react';
import { ButtonStyled } from './headerFileFeatures.styled';

export const DownloadButtonStyled = styled(ButtonStyled)`
  font-weight: ${props => props.theme.font.weight.regular};
  border-right: 1px solid ${props => props.theme.color.wfGrey900};
  &:hover {
    border-color: ${props => props.theme.color.wfGrey900};
  }
`;

export const StyledAccordion = styled(Accordion)`
  border: none;
  height: ${FrameHeaderHeight}px;
  border-right: 1px solid ${props => props.theme.color.wfGrey900};
  color: white;
  &:focus {
    outline: 0 !important;
  }
  position: relative;
`;
export const StyledAccordionItem = styled(AccordionItem)`
  border: none;
`;

export const StyledAccordionButton = styled(AccordionButton)`
  font-size: ${props => props.theme.font.size.xsmall};
  height: ${FrameHeaderHeight}px;
  outline: none;
  box-shadow: none !important;
  &:hover {
    opacity: 0.8;
  }
`;

export const StyledAccordionPanel = styled(AccordionPanel)`
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  position: absolute;
  min-width: 300px;
  right: 0;
`;

export const DownloadTextMain = styled.p`
  font-weight: 300;
`;
export const DownloadTextSecondary = styled.p`
  font-weight: 300;
  opacity: 0.5;
`;

export const DownloadIcon = styled.a`
  min-width: 200px;
`;

export const DownloadEntryRow = styled.div`
  display: grid;
  grid-template-columns: 9fr 5fr 1fr;
  grid-column-gap: 0.4em;
  height: ${BlockSize.height};
  color: white;
  padding: 0 10px;

  align-items: center;
  border: none;
  background-color: ${props => props.theme.color.wfBlack};
  font-weight: ${props => props.theme.font.weight.xbold};
  border-radius: 0;
  transform: translateY(-2px);
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.color.wfGrey500};
    background-color: ${props => props.theme.color.wfBlack};
    border-color: currentColor;
    text-decoration: none;
  }
`;
